import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A workspace saved size was selected for a generation or crop',
  name: 'saved_size_applied',
  params: [
    {
      description: 'Where the size was applied from',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['canvas_picker', 'crop'],
    },
    {
      description: 'The id of the saved size',
      name: 'size_preset_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
